import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../../Constants";
import LeavePlan from "../..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  isattachment: false,
  attachmentduration: 0,
  attachmentnote: "",
};
class ReqAttachment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const { InitLeavesPolicy } = props;
      this.setState({
        ParentIndex,
        leavetypeid: props.leavetypeid,
        leaveid: InitLeavesPolicy.policy[ParentIndex].leaveid,
        isattachment: InitLeavesPolicy.policy[ParentIndex].isattachment,
        attachmentduration:
          InitLeavesPolicy.policy[ParentIndex].attachmentduration,
        attachmentnote: InitLeavesPolicy.policy[ParentIndex].attachmentnote,
      });
    } else {
      this.setState({ ...ParentState });
    }
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isattachment: this.state.isattachment,
      attachmentduration: this.state.attachmentduration,
      attachmentnote: this.state.attachmentnote,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max)
        || Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  handleChange(name, ...arg) {
    switch (name) {
      case "isattachment": {
        this.setState(
          { isattachment: arg[0], attachmentduration: 0, attachmentnote: "" },
          () => {
            if (this.state.isattachment) {
              this.setState({ attachmentduration: 0 }, () => {
                this.UpdateReducer();
              });
            }
            this.UpdateReducer();
          },
        );
        break;
      }
      case "attachmentnote":
        this.setState({ attachmentnote: arg[0].target.value }, () => {
          this.UpdateReducer();
        });
        break;
      default:
        break;
    }
  }

  render() {
    const language = this.props.Language.reqattachment;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <div className="inner-wrapper opaque">
            <div className="">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbReqDocuments"
                  defaultMessage="Do you want to keep attachments (supporting documents) compulsory for this leave?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isattachment", true)}
                aria-expanded={this.state.isattachment == true}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.isattachment == true ? (
                  <span className="floatright x">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.isattachment}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <FormattedMessage
                    id="__LbDurationGreaterThan"
                    defaultMessage="Supporting documents are required only if leave duration is greater than"
                  />
                  <InputValues
                    min="0"
                    max="365"
                    field="attachmentduration"
                    onChange={this.CommonNumberChange.bind(
                      this,
                      "attachmentduration",
                      365,
                    )}
                    value={this.state.attachmentduration}
                    defaultvalue={this.state.attachmentduration}
                  />

                  <FormattedMessage id="__LbDays" defaultMessage=" day(s)" />
                  <br />
                  <br />
                  <FormattedMessage
                    id="__LbDocList"
                    defaultMessage="Please write an explanatory note visible to employee on the leave application form"
                  />
                  <div className="form-group margin-top-8">
                    {/* <TextArea
                     componentObj={componentObj}
                     _activeNext={this._activeNext}
                     _onChange={this.onChange}
                     parent={parent}
                   /> */}
                    <textarea
                      className="form-control width100"
                      placeholder="note..."
                      maxLength="1052"
                      onChange={this.handleChange.bind(this, "attachmentnote")}
                      value={this.state.attachmentnote}
                    />
                    {/* <input
                      type="text"
                      className="form-control"
                      autocomplete="off"
                      max="255"
                      autofocus
                      placeholder="Add Instructions"
                      onChange={this.handleChange.bind(this, "attachmentnote")}
                      value={this.state.attachmentnote}
                    /> */}
                  </div>
                </Collapse>
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isattachment", false)}
                aria-expanded={this.state.isattachment == false}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isattachment == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
ReqAttachment.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ReqAttachment)));
